(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fo-establishment-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fo-establishment-reviews'))customElements.define('fo-establishment-reviews',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.fo-reviews__track');this.pauseButton=this.querySelector('[data-review-pause]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.sync();this.querySelector('[data-review-prev]').addEventListener('click',()=>{this.stop();this.move(-1)});this.querySelector('[data-review-next]').addEventListener('click',()=>{this.stop();this.move(1)});this.pauseButton?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()});this.track.addEventListener('pointerdown',()=>this.stop());this.addEventListener('focusin',event=>{if(event.target!==this.pauseButton)this.stop()});this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover'))this.move(1)},5500)}
 disconnectedCallback(){clearInterval(this.timer);this.ready=false}
 sync(){if(!this.pauseButton)return;this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.play:this.pauseButton.dataset.pause)}
 stop(){this.paused=true;this.sync()}
 move(direction){const max=this.track.scrollWidth-this.track.clientWidth;if(max<2)return;const step=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);const edge=direction>0?this.track.scrollLeft>=max-2:this.track.scrollLeft<=2;this.track.scrollTo({left:edge?(direction>0?0:max):this.track.scrollLeft+direction*step,behavior:this.reduced.matches?'instant':'smooth'})}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fo-unifocal-configurator"] && !Shopify.designMode) return;
  try {
    /* Display bounds are not measurements and never replace the underlying estimate. */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.FoPdEstimateDisplay=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const validTotal=value=>typeof value==='number'&&Number.isFinite(value)&&value>=40&&value<=85;
  function describe(totalMm){
    if(!validTotal(totalMm))return null;
    const rounded=Math.round(totalMm);
    const boundary=rounded<=50?'low':rounded>=69?'high':null;
    const displayTotalMm=boundary==='low'?50:boundary==='high'?69:rounded;
    return {
      estimatedTotalMm:totalMm,displayTotalMm,boundary,
      fieldText:(boundary==='low'?'≤ ':boundary==='high'?'≥ ':'')+displayTotalMm,
      requiresOpticianCheck:true,usableForManufacture:false
    };
  }
  return {validTotal,describe};
});

/* Ephemeral, same-origin bridge. No photo, prescription or browser storage. */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.FoPdReturnTransfer=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const PROTOCOL='fo-pd-return-v1',PREFIX='fo-pd-',LIFETIME=30*60*1000;
  const validToken=value=>typeof value==='string'&&/^[a-f0-9]{32}$/.test(value);
  const validTotal=value=>FoPdEstimateDisplay.validTotal(value);
  function randomToken(){
    const bytes=new Uint8Array(16);crypto.getRandomValues(bytes);
    return Array.from(bytes,n=>n.toString(16).padStart(2,'0')).join('');
  }
  function supported(){return typeof BroadcastChannel==='function'&&typeof crypto==='object'&&typeof crypto.getRandomValues==='function';}
  function createHost({apply,resume}){
    let current=null;
    function dispose(){if(current){current.closed=true;current.channel.close();current=null;}}
    function begin(){
      dispose();if(!supported())return null;
      const token=randomToken(),channel=new BroadcastChannel(PREFIX+token);
      const session={channel,closed:false,expires:Date.now()+LIFETIME,requests:new Map()};
      current=session;
      channel.onmessage=async event=>{
        const data=event.data;
        if(current!==session||session.closed||Date.now()>session.expires||data?.protocol!==PROTOCOL||
          !validToken(data.requestId)||!['apply','review','resume'].includes(data.type))return;
        if(data.type==='apply'&&(!validTotal(data.totalMm)||data.method!=='iris_ratio_experimental'))return;
        if(data.type==='review'&&(data.method!=='optician_pending'||'totalMm' in data))return;
        const fingerprint=data.type+':'+(data.totalMm??'');
        const previous=session.requests.get(data.requestId);
        if(previous&&previous.fingerprint!==fingerprint)return;
        if(!previous){
          // Bound memory and never forward extra fields from another context.
          if(session.requests.size>=32)return;
          const operation=Promise.resolve().then(()=>data.type==='apply'?
            apply({requestId:data.requestId,totalMm:data.totalMm,method:'iris_ratio_experimental'}):
            data.type==='review'?apply({requestId:data.requestId,method:'optician_pending'}):resume())
            .then(ok=>ok===true,()=>false);
          session.requests.set(data.requestId,{fingerprint,operation});
        }
        const ok=await session.requests.get(data.requestId).operation;
        if(current===session&&!session.closed)channel.postMessage({protocol:PROTOCOL,requestId:data.requestId,type:'ack',ok});
      };
      return token;
    }
    return {begin,dispose};
  }
  function createClient(hash){
    if(!supported())return null;
    const token=new URLSearchParams(String(hash||'').replace(/^#/, '')).get('fo_pd');
    if(!validToken(token))return null;
    const channel=new BroadcastChannel(PREFIX+token),pending=new Map();let closed=false;
    channel.onmessage=event=>{
      const data=event.data;
      if(data?.protocol!==PROTOCOL||data.type!=='ack'||typeof data.ok!=='boolean')return;
      const operation=pending.get(data.requestId);if(!operation)return;
      clearTimeout(operation.timer);pending.delete(data.requestId);operation.resolve(data.ok);
    };
    function send(type,totalMm){
      if(closed||(type==='apply'&&!validTotal(totalMm)))return Promise.resolve(false);
      const requestId=randomToken();
      return new Promise(resolve=>{
        const timer=setTimeout(()=>{pending.delete(requestId);resolve(false);},8000);
        pending.set(requestId,{timer,resolve});
        const message={protocol:PROTOCOL,requestId,type};
        if(type==='apply'){message.totalMm=totalMm;message.method='iris_ratio_experimental';}
        if(type==='review')message.method='optician_pending';
        channel.postMessage(message);
      });
    }
    function dispose(){
      closed=true;channel.close();
      for(const operation of pending.values()){clearTimeout(operation.timer);operation.resolve(false);}
      pending.clear();
    }
    return {apply:totalMm=>send('apply',totalMm),review:()=>send('review'),resume:()=>send('resume'),dispose};
  }
  return {createHost,createClient,validTotal};
});

(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.FoUnifocalCart=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';

  const treatments={classic:'CLASSIC',blue:'BLUE',photo:'PHOTO'};
  const rxKeys=['od-sphere','od-cylinder','od-axis','og-sphere','og-cylinder','og-axis'];
  const validId=n=>Number.isSafeInteger(Number(n))&&Number(n)>0;
  function numeric(raw,code,{positive=false,axis=false}={}){
    if(raw===null||raw===undefined||String(raw).trim()==='')return '';
    const text=String(raw).trim().replace(/\u2212/g,'-').replace(',','.');
    if(text.length>24||!/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(text))throw Error(code);
    const number=Number(text);
    if(!Number.isFinite(number)||(positive&&number<=0)||(axis&&(!Number.isInteger(number)||number<0||number>180)))throw Error(code);
    return text;
  }
  function configuration(data){
    if(!data||!Object.hasOwn(treatments,data.treatment)||typeof data.thin!=='boolean')throw Error('configuration');
    const c={treatment:data.treatment,thin:data.thin,usage:['far','near'].includes(data.usage)?data.usage:'',
      pdMethod:['known','camera','help','review'].includes(data.pdMethod)?data.pdMethod:'review',
      rxMethod:['manual','upload'].includes(data.rxMethod)?data.rxMethod:'later',rxLater:data.rxLater===true,rxFile:null,rx:{},pd:{}};
    if(c.rxMethod==='manual'){
      for(const key of rxKeys)c.rx[key]=numeric(data.rx?.[key],'rx_error',{axis:key.endsWith('-axis')});
      for(const eye of ['od','og'])if(c.rx[eye+'-cylinder']!==''&&Number(c.rx[eye+'-cylinder'])!==0&&c.rx[eye+'-axis']==='')throw Error('rx_error');
    }
    if(c.rxMethod==='upload'){
      if(data.rxFile){
        const f=data.rxFile;
        const types={pdf:'application/pdf',jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png'};
        const extension=typeof f.name==='string'?f.name.split('.').pop().toLowerCase():'';
        if(typeof f.name!=='string'||f.name.length>255||!Number.isSafeInteger(f.size)||f.size<=0||f.size>10*1024*1024||!types[extension]||f.type!==types[extension])throw Error('rx_file_bad');
        if(f instanceof Blob)c.rxFile=f;
        else{
          if(!(f.bytes instanceof ArrayBuffer)||f.bytes.byteLength!==f.size)throw Error('rx_file_read');
          c.rxFile=new File([f.bytes],f.name,{type:f.type,lastModified:Number.isFinite(f.lastModified)?f.lastModified:0});
        }
      }else if(!c.rxLater)throw Error('upload_missing');
    }
    if(c.pdMethod==='known'){
      c.pd.format=data.pd?.format==='single'?'single':'dual';
      c.pd.kind=['far','near'].includes(data.pd?.kind)?data.pd.kind:'';
      for(const key of c.pd.format==='single'?['total']:['od','og'])c.pd[key]=numeric(data.pd?.[key],'pd_error',{positive:true});
    }
    if(c.pdMethod==='camera'){
      const estimate=data.pd?.estimate;
      if(typeof estimate!=='number'||!Number.isFinite(estimate)||estimate<40||estimate>85)throw Error('pd_error');
      c.pd.estimate=estimate;
    }
    return c;
  }
  function buildItems({data,frameId,lensVariants,token,labels}){
    const c=configuration(data);
    if(!validId(frameId)||!/^[a-f0-9]{32}$/.test(token))throw Error('configuration');
    const sku='FO-UNIF-'+treatments[c.treatment]+'-'+(c.thin?'THIN':'BASE');
    const lens=lensVariants.find(v=>v.sku===sku);
    if(!lens||!validId(lens.id)||lens.available!==true)throw Error('unavailable');
    const displayNumber=raw=>String(raw).replace('.',labels.summary_decimal||'.');
    const common={_fo_configuration:token,_fo_service:'unifocal'};
    const properties={[labels.usage]:labels[c.usage]||labels.unspecified};
    const details={_fo_atelier:labels.atelier};
    let rxStatus=labels.rx_pending;
    if(c.rxFile){properties[labels.rx_file]=labels.summary_rx_uploaded;details['_'+labels.rx_file]=c.rxFile;rxStatus=labels.rx_upload;}
    else if(c.rxMethod==='manual'){
      const hasCorrection=rxKeys.some(key=>c.rx[key]!=='');
      const complete=c.rx['od-sphere']!==''&&c.rx['og-sphere']!=='';
      rxStatus=hasCorrection?(complete?labels.rx_manual:labels.rx_partial):labels.rx_pending;
      properties[labels.rx_file]=hasCorrection?(complete?labels.summary_rx_manual:labels.summary_rx_partial):labels.summary_rx_pending;
      for(const eye of ['od','og']){
        const values=[];
        for(const part of ['sphere','cylinder','axis']){
          const key=eye+'-'+part,raw=c.rx[key];
          if(raw==='')continue;
          details['_'+labels[key]]=raw;
          const sign=part!=='axis'&&Number(raw)>0&&!raw.startsWith('+')?'+':'';
          values.push(labels['summary_'+part]+' '+sign+displayNumber(raw)+(part==='axis'?'°':''));
        }
        if(values.length)properties[eye==='od'?labels.summary_right:labels.summary_left]=values.join(' · ');
      }
    }else properties[labels.rx_file]=labels.summary_rx_pending;
    details['_'+labels.rx_status]=rxStatus;
    let pdStatus=labels.pd_pending,pdSummary=labels.summary_pending;
    if(c.pdMethod==='known'){
      const keys=c.pd.format==='single'?['total']:['od','og'];
      const values=[];
      for(const key of keys)if(c.pd[key]!==''){
        details['_'+labels['pd_'+key]]=c.pd[key];
        const caption=key==='od'?labels.summary_pd_right:key==='og'?labels.summary_pd_left:labels.summary_pd_total;
        values.push(caption+' '+displayNumber(c.pd[key])+' mm');
      }
      if(values.length){
        const complete=keys.every(key=>c.pd[key]!=='');
        pdStatus=complete?labels.pd_entered:labels.pd_partial;
        pdSummary=values.join(' · ');
        if(c.pd.kind)pdSummary+=' ('+labels[c.pd.kind]+')';
        if(!complete)pdSummary+=' — '+labels.summary_partial;
      }
      details['_'+labels.pd_kind]=labels[c.pd.kind]||labels.unspecified;
    }
    if(c.pdMethod==='camera'){
      details['_'+labels.pd_estimate]=String(c.pd.estimate);
      details._fo_pd_usable_for_manufacture='false';
      pdStatus=labels.pd_camera;pdSummary=labels.summary_camera;
    }
    properties[labels.summary_pd]=pdSummary;
    details['_'+labels.pd_status]=pdStatus;
    return [{id:Number(frameId),quantity:1,properties:{...common,_fo_role:'frame'}},
      {id:Number(lens.id),parent_id:Number(frameId),quantity:1,properties:{...properties,...details,...common,_fo_role:'lenses'}}];
  }

  function uploaded(value){
    if(typeof value!=='string')return false;
    try{const u=new URL(value,'https://cdn.shopify.com');return u.protocol==='https:'&&/(^|\.)(shopify\.com|myshopify\.com)$/.test(u.hostname)&&/\/uploads\//.test(u.pathname);}catch{return false;}
  }
  function matches(cart,items,token){
    const own=(cart?.items||[]).filter(i=>i.properties?._fo_configuration===token);
    const frame=own.find(i=>i.properties?._fo_role==='frame'),lens=own.find(i=>i.properties?._fo_role==='lenses');
    if(own.length!==2||Number(frame?.variant_id??frame?.id)!==items[0].id||Number(lens?.variant_id??lens?.id)!==items[1].id||frame.quantity!==1||lens.quantity!==1||lens.parent_relationship?.parent_key!==frame.key)return false;
    return [frame,lens].every((line,index)=>Object.entries(items[index].properties).every(([key,want])=>want instanceof Blob?uploaded(line.properties?.[key]):String(line.properties?.[key])===String(want)));
  }
  function payload(items){
    const body=new FormData();
    items.forEach((item,i)=>{
      for(const key of ['id','quantity','parent_id'])if(item[key]!==undefined)body.append('items['+i+']['+key+']',String(item[key]));
      for(const [key,value] of Object.entries(item.properties)){
        const name='items['+i+'][properties]['+key+']';
        if(value instanceof Blob)body.append(name,value,value.name);else body.append(name,String(value));
      }
    });
    return body;
  }
  async function add({fetcher,root,items,token}){
    const request=async(path,options={})=>{
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),options.method==='POST'?60000:15000);
      try{return await fetcher(path,{...options,signal:controller.signal});}
      finally{clearTimeout(timer);}
    };
    const read=async()=>{const r=await request(root+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('network');return r.json();};
    const clearOwn=async cart=>{
      const own=(cart.items||[]).filter(i=>i.properties?._fo_configuration===token);
      const frame=own.find(i=>i.properties?._fo_role==='frame');
      for(const line of frame?[frame,...own.filter(i=>i!==frame)]:own){
        const fresh=await read();if(!fresh.items.some(i=>i.key===line.key))continue;
        const removed=await request(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
        if(!removed.ok)throw Error('partial');
      }
    };
    const existing=await read();
    if(matches(existing,items,token))return existing;
    if((existing.items||[]).some(i=>i.properties?._fo_configuration===token))await clearOwn(existing);
    let response;
    try{response=await request(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:payload(items)});}
    catch{
      const recovered=await read();if(matches(recovered,items,token))return recovered;
      await clearOwn(recovered);throw Error('network');
    }
    const cart=await read();
    if(matches(cart,items,token))return cart;
    await clearOwn(cart);
    throw Error(response.ok?'incomplete':'unavailable');
  }
  return {configuration,buildItems,matches,add,payload};
});

if(!customElements.get('fo-unifocal-preview')){
  customElements.define('fo-unifocal-preview',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      const dialog=this.querySelector('dialog'),frame=this.querySelector('iframe');
      const ids=JSON.parse(this.dataset.variantIds),prices=JSON.parse(this.dataset.variantPrices),titles=JSON.parse(this.dataset.variantTitles);
      const cameraLink=this.querySelector('.fo-camera-link'),cameraBase=cameraLink.href;
      const pending=new Map();let opener,launchId=null;
      const lensVariants=JSON.parse(this.dataset.lensVariants||'[]');
      let selectedVariant=this.dataset.selectedVariant,cartBusy=false,cartAttempt=null;
      const openDialog=()=>{if(!dialog.open)dialog.showModal();};
      const bridge=FoPdReturnTransfer.createHost({
        apply:data=>new Promise(resolve=>{
          if(!frame.isConnected||!launchId){resolve(false);return;}
          openDialog();
          const timer=setTimeout(()=>{pending.delete(data.requestId);resolve(false);},4000);
          pending.set(data.requestId,{resolve,timer,launchId});
          frame.contentWindow.postMessage({type:'fo-pd-estimate',launchId,...data},'*');
        }),
        resume:()=>{openDialog();return true;}
      });
      this.disposeCamera=()=>{
        bridge.dispose();launchId=null;
        for(const operation of pending.values()){clearTimeout(operation.timer);operation.resolve(false);}
        pending.clear();
      };
      const cameraURL=()=>{
        this.disposeCamera();launchId=bridge.begin();
        const url=new URL(cameraBase,location.href);
        url.searchParams.delete('preview_theme_id');url.searchParams.set('view','ep-camera');
        const selected=document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if(ids.some(id=>String(id)===selected?.value))url.searchParams.set('variant',selected.value);
        if(launchId){url.hash='fo_pd='+launchId;frame.contentWindow.postMessage({type:'fo-pd-session',launchId},'*');}
        return url.href;
      };
      // The top link is a direct browser gesture, also available when popups are blocked.
      cameraLink.addEventListener('click',()=>{cameraLink.href=cameraURL();},options);
      window.addEventListener('message',event=>{
        if(event.source!==frame.contentWindow)return;
        const data=event.data;
        if(data?.type==='fo-cart-add'){
          if(cartBusy||typeof data.requestId!=='string'||!/^[a-f0-9]{32}$/.test(data.requestId))return;
          let configuration;
          try{configuration=FoUnifocalCart.configuration(data.configuration);}catch(error){frame.contentWindow.postMessage({type:'fo-cart-result',requestId:data.requestId,ok:false,reason:error.message},'*');return;}
          if(['nylor','rimless'].includes(this.dataset.mount))configuration.thin=true;
          const file=configuration.rxFile;
          const fingerprint=JSON.stringify({frame:selectedVariant,...configuration,rxFile:file?{name:file.name,size:file.size,type:file.type,lastModified:file.lastModified}:null});
          if(!cartAttempt||cartAttempt.fingerprint!==fingerprint){
            const bytes=new Uint8Array(16);crypto.getRandomValues(bytes);
            cartAttempt={fingerprint,token:Array.from(bytes,n=>n.toString(16).padStart(2,'0')).join('')};
          }
          cartBusy=true;
          const root=window.Shopify?.routes?.root||'/';
          Promise.resolve().then(()=>FoUnifocalCart.buildItems({data:configuration,frameId:selectedVariant,lensVariants,token:cartAttempt.token,labels:JSON.parse(this.dataset.orderLabels)}))
            .then(items=>FoUnifocalCart.add({fetcher:window.fetch.bind(window),root,items,token:cartAttempt.token}))
            .then(()=>{
              frame.contentWindow.postMessage({type:'fo-cart-result',requestId:data.requestId,ok:true},'*');
              const target=new URL(root+'cart',location.origin);
              location.assign(target.href);
            }).catch(error=>{
              cartBusy=false;
              frame.contentWindow.postMessage({type:'fo-cart-result',requestId:data.requestId,ok:false,reason:['rx_file_bad','rx_file_read','upload_missing','rx_error','pd_error','unavailable','incomplete'].includes(error.message)?error.message:'network'},'*');
            });
          return;
        }
        if(data?.type==='fo-open-pd-camera'){
          window.open(cameraURL(),'_blank','noopener,noreferrer');return;
        }
        if(data?.type==='fo-pd-applied'){
          const operation=pending.get(data.requestId);
          if(!operation||operation.launchId!==data.launchId||data.launchId!==launchId)return;
          clearTimeout(operation.timer);pending.delete(data.requestId);operation.resolve(true);
        }
      },options);
      document.addEventListener('click',event=>{
        const button=event.target.closest('[data-fo-unifocal-open]');if(!button||button.disabled)return;
        opener=button;
        const selected=document.querySelector('form[action*="/cart/add"] input[name="id"]');
        const index=ids.findIndex(id=>String(id)===selected?.value);
        if(index>=0){selectedVariant=String(ids[index]);frame.contentWindow.postMessage({type:'fo-frame',price:prices[index],title:this.dataset.productTitle+' · '+titles[index]},'*');}
        openDialog();
      },options);
      this.querySelector('.fo-unifocal-close').addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('close',()=>{frame.contentWindow.postMessage({type:'fo-close'},'*');opener?.focus();},options);
      window.addEventListener('pagehide',()=>this.disposeCamera(),options);
    }
    disconnectedCallback(){this.disposeCamera?.();this.controller?.abort();delete this.dataset.ready;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
